module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_normal_orange-89f3536f738861a5d59bf4e40cee8b15.svg";